import React, { useState } from 'react'
import { Box, Button, Typography, IconButton, useTheme } from '@material-ui/core'
import FormUpdate from './FormUpdate'
import { ArrowBack } from '@material-ui/icons'
import { Link } from 'react-router-dom'
import { useTranslate } from 'react-admin'
import GoBackButton from '../CustomizedUIs/GoBackButton'

const CreateChannel = () => {
    const theme = useTheme();
    const translate = useTranslate();

    return (
        <Box width='80%' m='auto'>
            <Box >
                <Box my={5} width={300} display='flex' component={Link} to={'/channel'} style={{ textDecoration: 'none' }}>
                    <Box display='flex' mr={2}>
                        <GoBackButton />
                    </Box>
                    <Typography variant="subtitle1" color="primary" style={{ margin: 'auto 0', fontWeight: 'bold' }}>{translate(`pos.channels.back`)}</Typography>
                </Box>
            </Box>
            <Box display='flex' justifyContent='center'>
                <Box width={500}>
                    <Box>
                        <Typography variant='h5' style={{ fontFamily: 'UniviaPro-Medium', fontWeight: 'normal', color: '#4f5064' }} >{translate(`pos.channels.addChannel`)}</Typography>
                    </Box>
                    <Box>
                        <FormUpdate />
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}
export default CreateChannel